import ToastMessage from './ToastMessage';
import { connect } from 'react-redux';
import {
  removeToastMessage,
  setRemovingToastMessage
} from '../ToastMessagesActions';

const mapDispatchToProps = {
  removeToastMessage,
  setRemovingToastMessage,
  userClickAction: setRemovingToastMessage,
};

export default connect(null, mapDispatchToProps)(ToastMessage);
